/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  AlertClearRequestV9,
  AlertListV9Response,
  AlertRuleDetailV9Response,
  AlertRuleExternalDetailV9Response,
  AlertRuleListV9Response,
  AlertRuleNotificationResponse,
  ApiResponseSystemAlertDetail,
  ExternalAlertRuleErrorV9Response,
  GetV9AlertsAlertRulesCurrentByAlertRuleIdParams,
  GetV9AlertsAlertRulesNotificationByAlertRuleIdParams,
  ResultResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 알람 룰 조회
 */
export const postV9AlertsAlertGroupsAlertRules = (
  postV9AlertsAlertGroupsAlertRulesBody: MaybeRef<string[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  postV9AlertsAlertGroupsAlertRulesBody = unref(postV9AlertsAlertGroupsAlertRulesBody);

  return customAxiosInstance<AlertRuleListV9Response>(
    {
      url: `/api/v9/alerts/alert-groups/alert-rules`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postV9AlertsAlertGroupsAlertRulesBody,
      signal,
    },
    options,
  );
};

export const getPostV9AlertsAlertGroupsAlertRulesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertsAlertGroupsAlertRules>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertsAlertGroupsAlertRules>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationKey = ['postV9AlertsAlertGroupsAlertRules'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertsAlertGroupsAlertRules>>,
    { data: BodyType<string[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV9AlertsAlertGroupsAlertRules(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertsAlertGroupsAlertRulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertsAlertGroupsAlertRules>>
>;
export type PostV9AlertsAlertGroupsAlertRulesMutationBody = BodyType<string[]>;
export type PostV9AlertsAlertGroupsAlertRulesMutationError = ErrorType<unknown>;

/**
 * @summary 알람 룰 조회
 */
export const usePostV9AlertsAlertGroupsAlertRules = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertsAlertGroupsAlertRules>>,
      TError,
      { data: BodyType<string[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertsAlertGroupsAlertRules>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationOptions = getPostV9AlertsAlertGroupsAlertRulesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알람 룰 Clear
 */
export const postV9AlertsAlertRulesClear = (
  alertClearRequestV9: MaybeRef<AlertClearRequestV9[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertClearRequestV9 = unref(alertClearRequestV9);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v9/alerts/alert-rules/clear`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: alertClearRequestV9,
      signal,
    },
    options,
  );
};

export const getPostV9AlertsAlertRulesClearMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertsAlertRulesClear>>,
    TError,
    { data: BodyType<AlertClearRequestV9[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertsAlertRulesClear>>,
  TError,
  { data: BodyType<AlertClearRequestV9[]> },
  TContext
> => {
  const mutationKey = ['postV9AlertsAlertRulesClear'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertsAlertRulesClear>>,
    { data: BodyType<AlertClearRequestV9[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV9AlertsAlertRulesClear(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertsAlertRulesClearMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertsAlertRulesClear>>
>;
export type PostV9AlertsAlertRulesClearMutationBody = BodyType<AlertClearRequestV9[]>;
export type PostV9AlertsAlertRulesClearMutationError = ErrorType<unknown>;

/**
 * @summary 알람 룰 Clear
 */
export const usePostV9AlertsAlertRulesClear = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertsAlertRulesClear>>,
      TError,
      { data: BodyType<AlertClearRequestV9[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertsAlertRulesClear>>,
  TError,
  { data: BodyType<AlertClearRequestV9[]> },
  TContext
> => {
  const mutationOptions = getPostV9AlertsAlertRulesClearMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 외부알람 룰 상세조회
 */
export const getV9AlertsAlertRulesExternalByAlertRuleId = (
  alertRuleId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertRuleId = unref(alertRuleId);

  return customAxiosInstance<AlertRuleExternalDetailV9Response>(
    { url: `/api/v9/alerts/alert-rules/external/${alertRuleId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV9AlertsAlertRulesExternalByAlertRuleIdQueryKey = (
  alertRuleId?: MaybeRef<string>,
) => {
  return ['api', 'v9', 'alerts', 'alert-rules', 'external', alertRuleId] as const;
};

export const getGetV9AlertsAlertRulesExternalByAlertRuleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsAlertRulesExternalByAlertRuleIdQueryKey(alertRuleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalByAlertRuleId>>
  > = ({ signal }) =>
    getV9AlertsAlertRulesExternalByAlertRuleId(alertRuleId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(alertRuleId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalByAlertRuleId>>,
    TError,
    TData
  >;
};

export type GetV9AlertsAlertRulesExternalByAlertRuleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalByAlertRuleId>>
>;
export type GetV9AlertsAlertRulesExternalByAlertRuleIdQueryError = ErrorType<unknown>;

/**
 * @summary 외부알람 룰 상세조회
 */

export function useGetV9AlertsAlertRulesExternalByAlertRuleId<
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsAlertRulesExternalByAlertRuleIdQueryOptions(
    alertRuleId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 외부알람 룰 에러
 */
export const getV9AlertsAlertRulesExternalErrorByAlertRuleId = (
  alertRuleId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertRuleId = unref(alertRuleId);

  return customAxiosInstance<ExternalAlertRuleErrorV9Response>(
    { url: `/api/v9/alerts/alert-rules/external/${alertRuleId}/error`, method: 'GET', signal },
    options,
  );
};

export const getGetV9AlertsAlertRulesExternalErrorByAlertRuleIdQueryKey = (
  alertRuleId?: MaybeRef<string>,
) => {
  return ['api', 'v9', 'alerts', 'alert-rules', 'external', alertRuleId, 'error'] as const;
};

export const getGetV9AlertsAlertRulesExternalErrorByAlertRuleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalErrorByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalErrorByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsAlertRulesExternalErrorByAlertRuleIdQueryKey(alertRuleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalErrorByAlertRuleId>>
  > = ({ signal }) =>
    getV9AlertsAlertRulesExternalErrorByAlertRuleId(alertRuleId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(alertRuleId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalErrorByAlertRuleId>>,
    TError,
    TData
  >;
};

export type GetV9AlertsAlertRulesExternalErrorByAlertRuleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalErrorByAlertRuleId>>
>;
export type GetV9AlertsAlertRulesExternalErrorByAlertRuleIdQueryError = ErrorType<unknown>;

/**
 * @summary 외부알람 룰 에러
 */

export function useGetV9AlertsAlertRulesExternalErrorByAlertRuleId<
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalErrorByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesExternalErrorByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsAlertRulesExternalErrorByAlertRuleIdQueryOptions(
    alertRuleId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 알람 룰 상세조회
 */
export const getV9AlertsAlertRulesByAlertRuleId = (
  alertRuleId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertRuleId = unref(alertRuleId);

  return customAxiosInstance<AlertRuleDetailV9Response>(
    { url: `/api/v9/alerts/alert-rules/${alertRuleId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV9AlertsAlertRulesByAlertRuleIdQueryKey = (alertRuleId?: MaybeRef<string>) => {
  return ['api', 'v9', 'alerts', 'alert-rules', alertRuleId] as const;
};

export const getGetV9AlertsAlertRulesByAlertRuleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsAlertRulesByAlertRuleId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsAlertRulesByAlertRuleIdQueryKey(alertRuleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertsAlertRulesByAlertRuleId>>> = ({
    signal,
  }) => getV9AlertsAlertRulesByAlertRuleId(alertRuleId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(alertRuleId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesByAlertRuleId>>,
    TError,
    TData
  >;
};

export type GetV9AlertsAlertRulesByAlertRuleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsAlertRulesByAlertRuleId>>
>;
export type GetV9AlertsAlertRulesByAlertRuleIdQueryError = ErrorType<unknown>;

/**
 * @summary 알람 룰 상세조회
 */

export function useGetV9AlertsAlertRulesByAlertRuleId<
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsAlertRulesByAlertRuleId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsAlertRulesByAlertRuleIdQueryOptions(alertRuleId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 알람 룰 실시간 알람
 */
export const getV9AlertsAlertRulesCurrentByAlertRuleId = (
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsAlertRulesCurrentByAlertRuleIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertRuleId = unref(alertRuleId);
  params = unref(params);

  return customAxiosInstance<AlertListV9Response>(
    {
      url: `/api/v9/alerts/alert-rules/${alertRuleId}/current`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV9AlertsAlertRulesCurrentByAlertRuleIdQueryKey = (
  alertRuleId?: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsAlertRulesCurrentByAlertRuleIdParams>,
) => {
  return [
    'api',
    'v9',
    'alerts',
    'alert-rules',
    alertRuleId,
    'current',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV9AlertsAlertRulesCurrentByAlertRuleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrentByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsAlertRulesCurrentByAlertRuleIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrentByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsAlertRulesCurrentByAlertRuleIdQueryKey(alertRuleId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrentByAlertRuleId>>
  > = ({ signal }) =>
    getV9AlertsAlertRulesCurrentByAlertRuleId(alertRuleId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(alertRuleId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrentByAlertRuleId>>,
    TError,
    TData
  >;
};

export type GetV9AlertsAlertRulesCurrentByAlertRuleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrentByAlertRuleId>>
>;
export type GetV9AlertsAlertRulesCurrentByAlertRuleIdQueryError = ErrorType<unknown>;

/**
 * @summary 알람 룰 실시간 알람
 */

export function useGetV9AlertsAlertRulesCurrentByAlertRuleId<
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrentByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsAlertRulesCurrentByAlertRuleIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrentByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsAlertRulesCurrentByAlertRuleIdQueryOptions(
    alertRuleId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 알람 룰 Notification 정보
 */
export const getV9AlertsAlertRulesNotificationByAlertRuleId = (
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsAlertRulesNotificationByAlertRuleIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertRuleId = unref(alertRuleId);
  params = unref(params);

  return customAxiosInstance<AlertRuleNotificationResponse>(
    {
      url: `/api/v9/alerts/alert-rules/${alertRuleId}/notification`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV9AlertsAlertRulesNotificationByAlertRuleIdQueryKey = (
  alertRuleId?: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsAlertRulesNotificationByAlertRuleIdParams>,
) => {
  return [
    'api',
    'v9',
    'alerts',
    'alert-rules',
    alertRuleId,
    'notification',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV9AlertsAlertRulesNotificationByAlertRuleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesNotificationByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsAlertRulesNotificationByAlertRuleIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesNotificationByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsAlertRulesNotificationByAlertRuleIdQueryKey(alertRuleId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesNotificationByAlertRuleId>>
  > = ({ signal }) =>
    getV9AlertsAlertRulesNotificationByAlertRuleId(alertRuleId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(alertRuleId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesNotificationByAlertRuleId>>,
    TError,
    TData
  >;
};

export type GetV9AlertsAlertRulesNotificationByAlertRuleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsAlertRulesNotificationByAlertRuleId>>
>;
export type GetV9AlertsAlertRulesNotificationByAlertRuleIdQueryError = ErrorType<unknown>;

/**
 * @summary 알람 룰 Notification 정보
 */

export function useGetV9AlertsAlertRulesNotificationByAlertRuleId<
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesNotificationByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsAlertRulesNotificationByAlertRuleIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesNotificationByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsAlertRulesNotificationByAlertRuleIdQueryOptions(
    alertRuleId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 시스템 알람 룰 상세조회
 */
export const getV9AlertsAlertRulesSystemByAlertRuleId = (
  alertRuleId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertRuleId = unref(alertRuleId);

  return customAxiosInstance<ApiResponseSystemAlertDetail>(
    { url: `/api/v9/alerts/alert-rules/${alertRuleId}/system`, method: 'GET', signal },
    options,
  );
};

export const getGetV9AlertsAlertRulesSystemByAlertRuleIdQueryKey = (
  alertRuleId?: MaybeRef<string>,
) => {
  return ['api', 'v9', 'alerts', 'alert-rules', alertRuleId, 'system'] as const;
};

export const getGetV9AlertsAlertRulesSystemByAlertRuleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesSystemByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesSystemByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsAlertRulesSystemByAlertRuleIdQueryKey(alertRuleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesSystemByAlertRuleId>>
  > = ({ signal }) => getV9AlertsAlertRulesSystemByAlertRuleId(alertRuleId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(alertRuleId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesSystemByAlertRuleId>>,
    TError,
    TData
  >;
};

export type GetV9AlertsAlertRulesSystemByAlertRuleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsAlertRulesSystemByAlertRuleId>>
>;
export type GetV9AlertsAlertRulesSystemByAlertRuleIdQueryError = ErrorType<unknown>;

/**
 * @summary 시스템 알람 룰 상세조회
 */

export function useGetV9AlertsAlertRulesSystemByAlertRuleId<
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesSystemByAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsAlertRulesSystemByAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsAlertRulesSystemByAlertRuleIdQueryOptions(
    alertRuleId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
